import { Component, Input, OnInit } from '@angular/core';
import { BundleInfo, CapacitorUpdater } from '@capgo/capacitor-updater'
import { NativeMarket } from '@capgo/native-market';
import { Platform } from '@ionic/angular';


@Component({
  selector: 'app-update',
  templateUrl: './update.page.html',
  styleUrls: ['./update.page.scss'],
})
export class UpdatePage {

  @Input() marketid = ''
  @Input() currentVersion = ''
  @Input() latestVersion = ''

  constructor(
    protected platform: Platform
  ) { }

  openMarket() {
    NativeMarket.openStoreListing({
      appId: this.marketid
    });
  }

}
